import { create } from 'zustand'

import type { RemoteCartInfo } from '@@types'
import type { ApolloError } from '@apollo/client'

interface CartInfoState {
  cartInfo: RemoteCartInfo | null
  cartInfoLoading: boolean
  cartInfoError: ApolloError | null
  refetchCartInfo: (() => Promise<unknown>) | null
  setCartInfo: (data: RemoteCartInfo | null) => void
  setCartInfoLoading: (loading: boolean) => void
  setCartInfoError: (error: ApolloError | null) => void
  setRefetchCartInfo: (refetch: (() => Promise<unknown>) | null) => void
}

export const useCartInfoStore = create<CartInfoState>()((set) => ({
  cartInfo: null,
  cartInfoLoading: false,
  cartInfoError: null,
  refetchCartInfo: null,
  setCartInfo: (data) => set({ cartInfo: data }),
  setCartInfoLoading: (loading) => set({ cartInfoLoading: loading }),
  setCartInfoError: (error) => set({ cartInfoError: error }),
  setRefetchCartInfo: (refetch) => set({ refetchCartInfo: refetch }),
}))
